/* unplugin-vue-components disabled */import { render } from "./ImplementationDetail2.vue?vue&type=template&id=961fa6c6&scoped=true"
import script from "./ImplementationDetail2.vue?vue&type=script&lang=js"
export * from "./ImplementationDetail2.vue?vue&type=script&lang=js"

import "./ImplementationDetail2.vue?vue&type=style&index=0&id=961fa6c6&lang=less&scoped=true"
import "./ImplementationDetail2.vue?vue&type=style&index=1&id=961fa6c6&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-961fa6c6"]])

export default __exports__